import Logger, { LogLevel } from './utils/logger.js';

/**
 * Configure the application logger.
 * Call this early in your application initialization.
 */
export function configureLogger() {
    // Detect environment based on hostname
    const isDevelopment = window.location.hostname.includes('localhost') || 
                         window.location.hostname === '127.0.0.1' ||
                         window.location.hostname.includes('cbg');
    
    console.log('🔧 Logger Configuration:', {
        hostname: window.location.hostname,
        isDevelopment,
        level: isDevelopment ? 'DEBUG' : 'WARN'
    });
    
    if (isDevelopment) {
        // Development: Show INFO and above by default
        // Uncomment below to enable DEBUG for specific modules during development
        Logger.configure(LogLevel.DEBUG);
        console.log('✅ Logger set to DEBUG level (shows all messages)');
        
        // To enable debug logging for specific modules:
        // Logger.configure(LogLevel.DEBUG, ['RemoteCon', 'RemoteRec', 'RPC']);
        
        // To enable all debug logging:
        // Logger.configure(LogLevel.DEBUG);
    } else {
        // Production: Show only WARN and ERROR
        Logger.configure(LogLevel.WARN);
        console.log('⚠️ Logger set to WARN level (production mode)');
        
        // To disable all logging in production:
        // Logger.configure(LogLevel.NONE);
    }
}

/**
 * Enable debug logging for specific modules.
 * Useful for troubleshooting specific issues.
 * 
 * Example usage:
 * ```typescript
 * import { enableDebugLogging } from './logger-config.js';
 * 
 * // Enable debug for WebRTC-related modules
 * enableDebugLogging(['RemoteCon', 'RemoteRec', 'RPC']);
 * ```
 */
export function enableDebugLogging(modules?: string[]) {
    Logger.configure(LogLevel.DEBUG, modules);
}

/**
 * Disable all logging (useful for performance testing).
 */
export function disableAllLogging() {
    Logger.configure(LogLevel.NONE);
}
